import { render, staticRenderFns } from "./AppPageShell.vue?vue&type=template&id=df705122&scoped=true&"
import script from "./AppPageShell.vue?vue&type=script&lang=js&"
export * from "./AppPageShell.vue?vue&type=script&lang=js&"
import style0 from "./AppPageShell.vue?vue&type=style&index=0&id=df705122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df705122",
  null
  
)

export default component.exports